let trigger = document.querySelectorAll('.js-menu-trigger'),
    menu = document.querySelector('.js-menu');



// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);


let menuOpen = false,
    menuBg = menu.querySelector('.js-menu-bg'),
    menuNav = menu.querySelectorAll('nav');

let menuAnim = gsap.timeline()
    .to(menuBg, { xPercent: 100 })
    .duration(.5)
    .paused(true);


  trigger.forEach(item => {
    item.addEventListener('click', event => {
      menu.classList.toggle("active");
      document.body.classList.toggle("menu-open");

      if(login && login.classList) {
        login.classList.remove('active');
      }

      document.body.classList.remove("login-open");

      search.classList.remove('active');
      document.body.classList.remove("search-open");

      gsap.set(menuNav, { zIndex: 2 });

      if (menuOpen == false) {
          console.log('play');
          menuAnim.play();
          menuOpen = true;
      } else {
          console.log('reverse');
          menuAnim.reverse();
          menuOpen = false;
      }
    })
  })

menu.style.visibility = "visible";
